(function () {
    function initHomeReviews(sectionElement) {
        if (!sectionElement || sectionElement.dataset.reviewsInitialized === 'true') {
            return;
        }

        var sliderElement = sectionElement.querySelector('[data-home-reviews-swiper]');

        if (!sliderElement || typeof window.Swiper === 'undefined') {
            return;
        }

        var slideCount = sliderElement.querySelectorAll('.swiper-slide').length;
        var paginationElement = sectionElement.querySelector('[data-home-reviews-pagination]');
        var prevElement = sectionElement.querySelector('[data-home-reviews-prev]');
        var nextElement = sectionElement.querySelector('[data-home-reviews-next]');

        sectionElement.dataset.reviewsInitialized = 'true';

        if (slideCount <= 1) {
            if (paginationElement) { paginationElement.hidden = true; }
            if (prevElement) { prevElement.hidden = true; }
            if (nextElement) { nextElement.hidden = true; }
            return;
        }

        var swiper = new window.Swiper(sliderElement, {
            slidesPerView: 1.1,
            spaceBetween: 12,
            speed: 500,
            watchOverflow: true,
            grabCursor: true,
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            breakpoints: {
                640: { slidesPerView: 2, spaceBetween: 16 },
                990: { slidesPerView: 3, spaceBetween: 16 }
            },
            pagination: paginationElement ? {
                el: paginationElement,
                clickable: true
            } : undefined,
            navigation: (prevElement && nextElement) ? {
                prevEl: prevElement,
                nextEl: nextElement
            } : undefined
        });

        // slides sometimes render at content-width if the section wasn't laid
        // out when Swiper initialised — force a recalculation once visible
        var recalc = function () { if (swiper && !swiper.destroyed) { swiper.update(); } };
        setTimeout(recalc, 60);
        setTimeout(recalc, 300);
        window.addEventListener('load', recalc);
        if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(function (entries) {
                if (entries[0] && entries[0].isIntersecting) { recalc(); io.disconnect(); }
            });
            io.observe(sliderElement);
        }
    }

    window.VitalifyHomeReviews = {
        init: initHomeReviews
    };
})();
